import { Link } from 'react-router-dom';
import { UserManagementTable } from '../components/admin/UserManagementTable';
import { usePageTitle } from '../hooks/usePageTitle';

export function UserManagementPage() {
  usePageTitle('User Management — Hawkes Bridge');

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-4">
        <Link
          to="/admin"
          className="text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          &larr; Back to Admin
        </Link>
      </div>
      <h1 className="text-2xl font-bold text-ink mb-6">User Management</h1>
      <UserManagementTable />
    </div>
  );
}
